import { render, staticRenderFns } from "./SettingsMeasurementComponent.vue?vue&type=template&id=5afa7525&scoped=true&lang=pug&"
import script from "./SettingsMeasurementComponent.vue?vue&type=script&lang=ts&"
export * from "./SettingsMeasurementComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsMeasurementComponent.vue?vue&type=style&index=0&id=5afa7525&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afa7525",
  null
  
)

export default component.exports